import moment from "moment";
import { convert24hourTo12hourTime } from "./dateHelper";

export const onFilter = () => (dataIndex, value, record) =>
  record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());

const parseSingleRecord = (record) => {
  // Map backend fields (snake_case, nested user) to frontend fields (camelCase, flat)
  const sportFieldMaping = {
    srinagar: {
      football: {
        1: "A",
        2: "B",
        3: "C",
      },
      "box-cricket": {
        1: "A",
        2: "B",
        3: "C",
        4: "D",
      },
      "cricket-net": {
        1: "A (3P)",
        2: "B (3P)",
        3: "A (6P)",
        4: "B (6P)",
      },
      "pickle-ball": {
        1: "A",
        2: "B",
        3: "C",
      },
    },
    baramulla: {
      "pickle-ball": {
        1: "A",
        2: "B",
        3: "C",
      },
    },
    jammu: {
      "pickle-ball": {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
      },
    },
  };

  const user = record.user || {};
  return {
    bookingId: record.booking_id || record.bookingId || record.id || "",
    transactionId: record.transaction_id || "",
    name: `${user.first_name || ""} ${user.last_name || ""}`.trim(),
    mobileNo: user.mobile_number || "",
    turf:
      sportFieldMaping[record.location]?.[record.sport]?.[record.turf_number] ||
      "",
    bookingDate: record.booking_timestamp
      ? moment(new Date(record.booking_timestamp)).format("DD/MM/yyyy")
      : "",
    playingDate: record.slot_date || "",
    startTime: record.slot_time
      ? convert24hourTo12hourTime(record.slot_time).toString()
      : "",
    duration: record.duration || "",
    totalAmount: (parseFloat(record.total_amount) || 0) + " ₹",
    amountPaid: (parseFloat(record.amount) || 0) + " ₹",
    remainingAmount: (parseFloat(record.remaining_amount) || 0) + " ₹",
    bookingStatus: record.booking_status || "",
    sport: record.sport || "",
    location: record.location || "",
    orderId: record.order_id || "",
    userId: record.user_id || "",
    notes: record.notes || "",
    // Preserve equipment details for expandable rows
    booking_equipment: record.booking_equipment || [],
    equipment_total: record.equipment_total || 0,
    // Add any other fields needed for the table
  };
};

export const parseBookingRecords = (list) => {
  if (!list || !Array.isArray(list)) {
    return [];
  }
  return list.map((i) => parseSingleRecord(i));
};
